export const PLEASE_SELECT = "Please Select";
export const NONE_SELECTED = "None Selected";
export const SELECT_DATED_PLAN = "Select Dated Plan";
export const SELECT_TEMPLATE = "Select Template";
export const PLAN_NAME_LIMIT =
  "Plan name must be under 40 characters in length";

export const SELECT_SIMULATION = "Simulation Data Found";

export const DAY = "DAY";
export const DATED = "DATED";
export const TEMPLATE = "TEMPLATE";
export const PLAN = "PLAN";

export const COPY_ONLY_PLAN = "COPY_ONLY_PLAN";
export const COPY_PLAN_WITH_DRIVERS = "COPY_PLAN_WITH_DRIVERS";

// MATRIX PROFILE PLAN TYPES
export const CHOICE = "Connect";
export const ROBOTS = "Robots";
export const SMALLS = "Smalls";
export const BULK = "Bulk";
export const DEFAULT = "Default";
export const COLLECTIONS = "Collections";
export const OVERRIDES = "Overrides";
export const LOCATIONS = "Locations";
export const PICKUP = "Pickup";

export const DEFAULT_TIMEBAND = "default";

export const NONE = "« none »";
export const MANUAL = "« manual »";
export const NO_DRIVER = "« no driver »";

export const defaultRoutesShortcuts = {
  NCD: "NCD",
  UNK: "UNK",
  TBB: "TBB",
  CFD: "CFD",
  FRA: "FRA",
  GOH: "GOH",
  UNASS: "000",
};

export const OWNERSHIP = {
  ALL: "ALL",
  SOME: "SOME",
  NONE: "NONE",
};

export const ALL = "All";
export const FILTER = "FILTER";

export const SHORT_DAYS = {
  0: "Su",
  1: "Mo",
  2: "Tu",
  3: "We",
  4: "Th",
  5: "Fr",
  6: "Sa",
};

export const DAYS = {
  0: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
};

export const FULL_DAYS = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const DAYS_TO_NUMBER = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 0,
};

export const MATRIX_TYPE_MISSING = "Please Select a Matrix Type";
export const MATRIX_DAY_MISSING = "Please Select a Date or Day";

export const MONTHS = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};
export const MAX_YEARS = 10;

export const BLANK = "blank";
export const EXISTING_PLAN = "existing-plan";
export const FROM_TEMPLATE = "template";

export const EXISTING_PLAN_PROFILE = "Existing Plan Profile";
export const DAILY_PROFILE = "Daily Profile";

export const POSTCODE = "POSTCODE";
export const LOCATION = "LOCATION";
export const ROUTE = "ROUTE";
export const DRIVER = "DRIVER";
export const SECTION = "SECTION";
export const SHIFT_MANAGER = "SHIFT_MANAGER";

export const SEARCH_OPTIONS = {
  [POSTCODE]: "Search Postcode",
  [LOCATION]: "Search Location",
  [ROUTE]: "Search Route",
  [DRIVER]: "Search Driver",
  [SECTION]: "Search Section",
};

export const MATRIX_MODES = {
  NONE_SELECTED: "NONE-SELECTED",
  VIEW: "VIEW",
  EDIT: "EDIT",
  EDIT_ONE_ROUTE: "EDIT_ONE_ROUTE",
  WAVES_EDIT: "WAVES_EDIT",
  COLLECTION_TIMES_EDIT: "COLLECTION_TIMES_EDIT",
};

export const MULTIPLE_ROUTES_EXIST_IN_AREA =
  "Multiple routes exist in this area. You have the following options:";
export const YOU_HAVE_ELECTED_TO_REMOVE = (routeCode, postcode) =>
  `You have elected to remove ${routeCode} from ${postcode}. You have the following options:`;

export const LEAVE_UNALLOCATED = "Leave unallocated";
export const SET_TO_NEXT = "Set to the next wave route";
export const SET_TO_ABOVE = "Set to the route from the level above";

export const REPLACE_UNALLOCATED =
  "Replace all unallocated on this level and level below";
export const REPLACE_THIS_LEVEL = (affectedRouteCode) =>
  `Replace only ${affectedRouteCode} allocation on this level and level below.`;
export const REPLACE_LEVEL_ONLY = `Replace only allocations on the selected postcode level.`;
export const REPLACE_ALL = "Replace all allocations below with this route";

export const SAVE_PLAN_BEFORE_EDITING_DRIVER =
  "Please save changes to the plan first before editing driver details";
export const EDIT_MODE_ACTIVE_WARNING =
  "Edit mode is active. Please Save or Cancel all current changes to the plan and try again.";
export const MAP_EDIT_MODE_ACTIVE_WARNING =
  "Map edit mode is active. Please Save or Cancel all current changes to the map and try again.";

export const EDIT_ARTIFICIAL_POSTCODE_ACTIVE_WARNING = (postcode) =>
  `You have unsaved changes to postcode ${postcode} location. Please save or cancel them first and then try again.`;
export const EDIT_ONE_MODE_ACTIVE_WARNING = (routeCode) =>
  `You have unsaved changes to route ${routeCode}. Please save or cancel them first and then try again.`;
export const WAVE_EDIT_MODE_WARNING =
  "Wave Edit mode is active. Please Apply or Cancel current changes to the plan waves and try again";
export const COLLECTION_EDIT_TIMES_WARNING =
  "Collection Times Edit mode is active. Please Save or Cancel all current changes to the plan and try again";
export const COLLECTION_TYPE_CHANGE_ON_EDIT_WARNING =
  "Collection Edit mode is active. Please Apply or Cancel current changes to the plan before changing collection type";
export const DRIVER_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING = ({
  driverCode,
  driverName,
}) =>
  `You have unsaved changes to driver ${
    driverCode.split("*")[1]
  } ${driverName}. Please save or cancel them first and then try again.`;
export const SELECTING_DRIVER_LOCATION_ACTIVE_WARNING =
  "Please apply or cancel driver location changes and try again.";
export const PROFILE_LOCKED_BY_WARNING = (username) =>
  `Action not allowed. The profile is locked by ${username}.`;
export const PROFILE_LOCKED_IN_OTHER_BROWSER = `Action not allowed. The profile is locked by you in different browser.`;
export const ROUTE_DAY_LOCKED_BY_WARNING = ({
  routeCode,
  dayOfWeek,
  lockedByUserName,
}) =>
  `Action not allowed. Route ${routeCode} ${FULL_DAYS[dayOfWeek]} is locked by ${lockedByUserName}.`;
export const ROUTE_DAY_NOT_SUITABLE_WARNING = ({
  driverCode,
  driverName,
  routeCode,
  dayOfWeek,
}) =>
  `Driver ${driverCode.split("*")[1]} ${driverName} ${
    FULL_DAYS[dayOfWeek]
  } route ${routeCode} is no longer suitable for a driver and has been unallocated.`;

export const CLEAR_ROUTE_WARNING_TITLE = "WARNING: CLEAR ROUTE";
export const CLEAR_ROUTE_WARNING_DELIVERIES = ({ routeCode }) =>
  `Are you sure you want to remove all delivery areas from route ${routeCode}?`;
export const CLEAR_ROUTE_WARNING_SAME_DAY_COLLECTIONS = ({ routeCode }) =>
  `Are you sure you want to remove all same day collections from route ${routeCode}?`;
export const CLEAR_ROUTE_WARNING_PLANNED_COLLECTIONS = ({ routeCode }) =>
  `Are you sure you want to remove all planned collections from route ${routeCode}?`;
export const CLEAR_ROUTE_WARNING_OVERRIDES = ({ routeCode }) =>
  `Are you sure you want to remove all overrides from route ${routeCode}?`;
export const CLEAR_ROUTE_WARNING_PICKUP = ({ routeCode }) =>
  `Are you sure you want to remove all pickup areas from route ${routeCode}?`;
export const CLEAR_ROUTE_WARNING_LOCATIONS = ({ routeCode }) =>
  `Are you sure you want to remove all locations from route ${routeCode}?`;

export const CANCEL_ALL_WARNING_TITLE = "WARNING: CANCEL ALL";
export const CANCEL_ALL_WARNING =
  "Are you sure you want to cancel all? You will lose all changes since the last save.";

export const PLAN_FAILED_TO_LOCK = `Failed to lock plan.`;
export const PLAN_FAILED_TO_UNLOCK = `Failed to unlock plan.`;

export const DRIVER_PROFILE_HAS_CHANGED = ({ names = [] }) =>
  names.length < 2
    ? `Driver ${[names]} profile has changed. Reloading driver.`
    : `Driver profiles ${names.join(", ")} have changed. Reloading drivers.`;

export const DRIVER_PROFILE_SUCESSFULLY_LOCKED = ({ driverCode, driverName }) =>
  `Successfully locked ${driverCode?.split("*")?.[1]} ${driverName} profile`;
export const DRIVER_PROFILE_FAILED_TO_LOCK = ({ driverCode, driverName }) =>
  `Failed to lock ${driverCode?.split("*")?.[1]} ${driverName} profile`;

export const DRIVER_PROFILE_SUCESSFULLY_UNLOCKED = ({
  driverCode,
  driverName,
}) =>
  `Successfully unlocked ${driverCode?.split("*")?.[1]} ${driverName} profile`;

export const DRIVER_PROFILE_FAILED_TO_UNLOCK = ({ driverCode, driverName }) =>
  `Failed to unlock ${driverCode?.split("*")?.[1]} ${driverName} profile`;

export const DRIVER_DAY_HAS_CHANGED = ({ names = [] }) =>
  names.length < 2
    ? `Driver ${[names]} day has changed. Reloading driver.`
    : `Driver days ${names.join(", ")} have changed. Reloading drivers.`;

export const DRIVER_DAY_SUCESSFULLY_LOCKED = (
  { driverCode, driverName },
  dayOfWeek
) =>
  `Successfully locked ${driverCode?.split("*")?.[1]} ${driverName} ${
    FULL_DAYS[dayOfWeek]
  }`;

export const DRIVER_DAY_SUCESSFULLY_UNLOCKED = (
  { driverCode, driverName },
  dayOfWeek
) =>
  `Successfully unlocked ${driverCode?.split("*")?.[1]} ${driverName} ${
    FULL_DAYS[dayOfWeek]
  }`;

export const DRIVER_DAY_FAILED_TO_LOCK = (
  { driverCode, driverName },
  dayOfWeek
) =>
  `Failed to lock ${driverCode?.split("*")?.[1]} ${driverName} ${
    FULL_DAYS[dayOfWeek]
  }`;

export const DRIVER_DAY_FAILED_TO_UNLOCK = (
  { driverCode, driverName },
  dayOfWeek
) =>
  `Failed to unlock ${driverCode?.split("*")?.[1]} ${driverName} ${
    FULL_DAYS[dayOfWeek]
  }`;

export const ROUTE_DAY_HAS_CHANGED = ({ codes = [] }) =>
  codes.length < 2
    ? `Route ${[codes]} day has changed. Reloading route.`
    : `Route days ${codes.join(", ")} have changed. Reloading routes.`;

export const ROUTE_DAY_SUCESSFULLY_LOCKED = (routeCode, dayOfWeek) =>
  `Successfully locked route ${routeCode} ${FULL_DAYS[dayOfWeek]}`;

export const ROUTE_DAY_SUCESSFULLY_UNLOCKED = (routeCode, dayOfWeek) =>
  `Successfully unlocked route ${routeCode} ${FULL_DAYS[dayOfWeek]}`;

export const ROUTE_DAY_FAILED_TO_LOCK = (routeCode, dayOfWeek) =>
  `Failed to lock route ${routeCode} ${FULL_DAYS[dayOfWeek]}`;

export const ROUTE_DAY_FAILED_TO_UNLOCK = (routeCode, dayOfWeek) =>
  `Failed to unlock route ${routeCode} ${FULL_DAYS[dayOfWeek]}`;

export const DRIVER_FORCE_UNLOCK_FAILED = "Failed to unlock depot drivers";

export const ERROR_UNABLE_TO_SELECT_LEVEL = (selectedLevel, postcodeLevel) =>
  `Unable to select ${postcodeLevel.toLowerCase()} due to current ${selectedLevel.toLowerCase()} selection.`;

export const WARNING_DRIVERLESS_ROUTES =
  "The following routes are allocated to territory without a driver";
export const WARNING_DRIVERLESS_ROUTES_TITLE = "WARNING: DRIVERLESS ROUTES";
export const ERROR_DRIVERLESS_ROUTES =
  "The following routes are allocated to territory without a driver";
export const ERROR_DRIVERLESS_ROUTES_TITLE = "ERROR: DRIVERLESS ROUTES";

export const ERROR_UNALLOCATED_POSTCODES =
  "Unable to save as there are unallocated postcode areas on this plan";
export const ERROR_UNALLOCATED_POSTCODES_TITLE = "ERROR: UNALLOCATED POSTCODES";
export const WARNING_UNALLOCATED_POSTCODES =
  "There are Unallocated Postcode Areas in this Template. If you continue to save, you will not be able to use this template to copy to an existing plan until you have allocated the postcode areas";
export const WARNING_UNALLOCATED_POSTCODES_TITLE =
  "WARNING: UNALLOCATED POSTCODES";

export const WARNING_SINGLE_WAVE_POSTCODES =
  "The following postcode areas have only 1 wave defined in the default plan type. Do you wish to continue?";
export const WARNING_SINGLE_WAVE_POSTCODES_TITLE =
  "WARNING: SINGLE WAVE POSTCODES";

export const OVERRIDE_AT_DIFFERENT_LEVEL =
  "Rule is defined at a different level, please select correct level to modify";
export const ERROR_OVERRIDE_CONFLICTS =
  "Unable to save as the following postcode areas have override conflicts on this plan";
export const ERROR_OVERRIDE_CONFLICTS_TITLE = "ERROR: OVERRIDE CONFLICTS";
export const UNABLE_TO_CONTINUE_CLEAR_CONFLICTS =
  "Unable to continue, please clear conflicts";

export const ERROR_NOT_OPTIMISED_TITLE = "ERROR: NOT OPTIMISED";
export const ERROR_NOT_OPTIMISED = `When you have a Volume Overlay applied, you must select "Optimise" first before you can select the "Extract CSV" option`;

export const ERROR_AREA_NOT_AVAILABLE = "Area data not available";
export const ERROR_PROCESSING_EDIT =
  "Encountered error while processing plan edit";
export const ERROR_ANALYZING_MAP = "Encountered error while analizing map area";

export const INVALID_TIME_FORMAT = "Invalid Time Format HH:MM";
export const INVALID_STOP_TIME_FORMAT = "Invalid Time Format mm:ss";
export const EDIT_PLAN_SATURN_AUTO =
  "Send to Saturn Value must be 'YES' or 'NO'";
export const EARLIEST_READY_TIME_COLLECTION_ERROR =
  "Time Must be 3 hours or More Prior to Latest Ready Time";
export const LATEST_READY_TIME_COLLECTION_ERROR =
  "Time Must be 3 hours or More after to Earliest Ready Time";
export const START_TIME_MUST_BE_BEFORE_END_TIME = (minutes) =>
  `Start Time must be at least ${minutes} minutes before the End Time`;
export const END_TIME_MUST_BE_AFTER_START_TIME = (minutes) =>
  `End Time must be at least ${minutes} minutes after the Start Time`;
export const START_TIME_MUST_BE_BEFORE_MIN_TO_MIDNIGHT = (minutes) =>
  `Start Time must be at least ${minutes} minutes before 23:59`;
export const END_TIME_MUST_BE_AFTER_MIDNIGHT = (minutes) =>
  `End Time must be at least ${minutes} minutes after 00:00`;

export const WAVES = "Waves";
export const TIMELINE = "Timeline";
export const SET_TIME = "Set Time";
export const REMOVE_TIME = "Remove Time";
export const CANCEL = "Cancel";
export const APPLY = "Apply";

export const ROUTE_NOT_FOUND = (routeCode) => `Route ${routeCode} not found`;
export const ROUTE_NOT_SUITABLE = (routeCode) =>
  `Route ${routeCode} is not suitable`;
export const INVALID_ROUTE_CODE = `Invalid route code`;

export const DRIVER_NOT_SUITABLE = (driverCode) =>
  `Driver ${driverCode.split("*")[1]} is not suitable`;
export const DRIVER_IS_REQUIRED_FOR_AN_ODF = "Driver is required for an odf";
export const THIS_DRIVER_REQUIRES_AN_ODF =
  "This driver requires an odf to be selected";
export const DUTY_START_MUST_BE_BEFORE_DUTY_END =
  "Duty start time must be before duty end time";
export const DUTY_START_MUST_BE_BEFORE_RETURN =
  "Duty start time must be before return time";
export const DUTY_START_MUST_BE_BEFORE_DEPART =
  "Duty start time must be before depart time";
export const DUTY_END_MUST_BE_AFTER_DUTY_START =
  "Duty end time must be after duty start time";
export const DUTY_END_MUST_BE_AFTER_DEPART =
  "Duty end time must be after depart time";
export const DUTY_END_MUST_BE_AFTER_RETURN =
  "Duty end time must be after return time";
export const TOTAL_DUTY_MUST_BE_AT_LEAST = (minDutyTime) =>
  `Total duty time must be at least ${minDutyTime}`;
export const TOTAL_DUTY_EXCEEDS_MAX_DUTY = (maxDutyTime) =>
  `Total duty time must not exceed ${maxDutyTime}`;
export const DEPART_MUST_BE_BEFORE_RETURN =
  "Depart time must be before return time";
export const DEPART_MUST_BE_AFTER_DUTY_START =
  "Depart time must be after duty start time";
export const DEPART_MUST_BE_BEFORE_DUTY_END =
  "Depart time must be before duty end time";
export const RETURN_MUST_BE_AFTER_DEPART =
  "Return time must be after depart time";
export const RETURN_MUST_BE_AFTER_DUTY_START =
  "Return time must be after duty start time";
export const RETURN_MUST_BE_BEFORE_DUTY_END =
  "Return time must be before duty end time";
export const AM_TIME_IN_DEPOT_CANT_BE_GREATER = (maxAmTimeInDepot) =>
  `AM time in depot can't be greater then ${maxAmTimeInDepot}`;
export const PM_TIME_IN_DEPOT_CANT_BE_GREATER = (maxPmTimeInDepot) =>
  `PM time in depot can't be greater then ${maxPmTimeInDepot}`;
export const SECTION_IS_REQUIRED = "Section is required";

// DRIVER MANAGEMENT DRIVER PROFILE ERRORS
export const PHONE_NUMBER_IS_REQUIRED = "Phone number is required";
export const INVALID_PHONE_NUMBER = "Invalid phone number format";
export const DRIVER_TYPE_IS_REQUIRED = "Driver type is required";
export const VEHICLE_TYPE_IS_REQUIRED = "Vehicle type is required";
export const START_DATE_IS_REQUIRED = "Start date is required";
export const AVERAGE_DELIVERIES_IS_REQUIRED = "Average deliveries is required";

// ROUTE MANAGEMENT
export const ROUTE_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING = ({ routeCode }) =>
  `You have unsaved changes to the route ${routeCode}. Please save or cancel them first and then try again.`;

// SECTION MANAGEMENT
export const SECTION_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING = ({ sectionName }) =>
  `You have unsaved changes to the section ${sectionName}. Please save or cancel them first and then try again.`;

// SHIFT MANAGER MANAGEMENT
export const SHIFT_MANAGER_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING = ({
  shiftManagerCode,
  shiftManagerName,
}) =>
  `You have unsaved changes to the shift manager ${shiftManagerCode} ${shiftManagerName}. Please save or cancel them first and then try again.`;

export const DEFAULT_SECTION_CANNOT_BE_REMOVED = `Default section cannot be removed.`;
export const SECTION_WITH_ALLOCATED_DRIVERS_CANNOT_BE_REMOVED = `Section with allocated drivers cannot be removed.`;
